import { render, staticRenderFns } from "./WorkflowKanbanPopupFields.vue?vue&type=template&id=3b2465bf&"
import script from "./WorkflowKanbanPopupFields.vue?vue&type=script&lang=ts&"
export * from "./WorkflowKanbanPopupFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports